/* eslint-disable no-underscore-dangle */
import 'idwpolygon'
import * as L from 'leaflet'
import { uniq } from 'lodash'
import React, { useEffect, useRef } from 'react'
import { tryError } from '../../services/Afins'
import { Container } from './styled'
import { cores_monitoramento, cores_monitoramento_invertido } from '../monitoramento/meta'

interface CanvasInterpolationProps {
  dataGroundOverlay: TypesGerarGroupOverlay[]
  onOverlayView: (overlay: TypesOverlayView[]) => void
}

export interface TypesOverlayView {
  url: string
  praga: string
  boundsL: L.LatLngBoundsExpression
  bounds: {
    north: number
    south: number
    east: number
    west: number
  }
  key: string
  polygon?: google.maps.LatLngLiteral[]
  cor?: string
}

export interface TypesGerarGroupOverlay {
  key?: string
  nivelVari: string
  talhao_observacao: string
  praga?: [number, number, string][]
  polyCoord: L.LatLngTuple[]
  inverterEscala: boolean
  isAgrupamento?: boolean
  coord_talhoes_agrupamento?: any[]
}

export function gerarGroupOverlay(data: TypesGerarGroupOverlay[]) {

  try {
    const polygon = new L.Polygon([], { weight: 0, fillOpacity: 1 })

    let dataFim = []
    for (let i = 0; i < data.length; i++) {
      const idw = data[i]
      const polygonGoogle = new google.maps.Polygon({
        paths: idw.polyCoord.map((rec) => {
          return { lat: rec[0], lng: rec[1] }
        }),
      })

      let temp = []

      idw.praga.forEach((item) => {
        const checkPraga = google.maps.geometry.poly.containsLocation(
          new google.maps.LatLng({ lat: item[0], lng: item[1] }),
          polygonGoogle
        )

        if (checkPraga) {
          temp = [...temp, item]
        }
      })

      idw.praga = temp

      dataFim = [...dataFim, idw]
    }

    const overlay = dataFim.map((rec, i) => {
      const map: L.Map = new L.Map(`map_${i}`).setView([0, 0], 13)
      polygon.setLatLngs(rec.polyCoord)
      const bounds = map.fitBounds(polygon.getBounds())

      const sizePragas = uniq(rec.praga.map((p) => parseFloat(p[2]).toFixed(1)))

      const grad = rec.inverterEscala ? cores_monitoramento_invertido : cores_monitoramento

      let url = ''
      // if (rec.praga.length > 2 && sizePragas.length > 1) {
      if (rec.praga.length > 0 && sizePragas.length > 1) {
        // @ts-ignore

        const idw = new L.IdwLayer(rec.praga, rec.polyCoord, {
          opacity: 1,
          maxZoom: 18,
          cellSize: 3,
          gradient: grad,
          exp: 2, //raio do blur
          max: 1, //cor do blur
          min: -1,
        }).addTo(map)
        url = idw._canvas.toDataURL()
      } else {
        url = null
      }
      // map.removeLayer(idw)

      document.getElementById(`map_${i}`)?.remove()

      return {
        url,
        praga: rec.nivelVari,
        boundsL: bounds.getBounds(),
        bounds: {
          north: bounds.getBounds().getNorth(),
          south: bounds.getBounds().getSouth(),
          east: bounds.getBounds().getEast(),
          west: bounds.getBounds().getWest(),
        },
        key: rec.key,
        ...(url === null
          ? {
              polygon: rec.polyCoord.map((item) => {
                return { lat: item[0], lng: item[1] }
              }),
              cor:
                // rec.praga.length <= 2 ? '#acacac' : grad[Number(Number(sizePragas[0]).toFixed(1))],
                rec.praga.length <= 0 ? '#acacac' : grad[Number(Number(sizePragas[0]).toFixed(1))],
            }
          : {
              polygon: rec.polyCoord.map((item) => {
                return { lat: item[0], lng: item[1] }
              }),
            }),
      }
    })

    return overlay
  } catch (error) {
    tryError(error)
  }
}

const CanvasInterpolation: React.FC<CanvasInterpolationProps> = (props) => {
  const { onOverlayView, dataGroundOverlay } = props
  const refMaster = useRef<HTMLDivElement>();

  function verificarDataGround() {

    let isAgrupamento: boolean = Boolean(dataGroundOverlay?.[0]?.isAgrupamento);
    const lista_pragas = dataGroundOverlay?.[0]?.praga; 

    if (isAgrupamento) {
      const unificar_pragas = uniq((dataGroundOverlay?.[0]?.praga).map((p) => parseFloat(p[2]).toFixed(1)))


      if (unificar_pragas.length === 1) {
        let lista_talhoes = (dataGroundOverlay?.[0]?.coord_talhoes_agrupamento)?.map(({coordenadas_talhao})=> coordenadas_talhao);
        let lista_coords_talhoes = lista_talhoes.map((item)=> item.map((sub)=> [sub.latitude, sub.longitude]) );
        

        let nova_estrutura: TypesGerarGroupOverlay[] = lista_coords_talhoes.map((coords, index)=> {
            return {
              inverterEscala: dataGroundOverlay?.[0]?.inverterEscala,
              isAgrupamento: true,
              nivelVari: dataGroundOverlay?.[0]?.nivelVari,
              praga: [ [coords?.[0][0], coords?.[0][1], lista_pragas?.[0]?.[2]], [coords?.[1][0], coords?.[1][1], lista_pragas?.[0]?.[2]], [coords?.[2][0], coords?.[2][1], lista_pragas?.[0]?.[2]] ] ,
              talhao_observacao: dataGroundOverlay?.[0]?.talhao_observacao,
              polyCoord: coords,
              codTalhao: index, 
              nameTalhao: `random_${index}`,
            }
        })

        console.log("dataGroundOverlay: ", dataGroundOverlay)
        console.log("nova_estrutura: ", nova_estrutura)

        return nova_estrutura;
      }
      
      else {
        return dataGroundOverlay;
      }
    }
    
    return dataGroundOverlay;
  }

  useEffect(() => {
    const divMaster = refMaster.current
    divMaster.innerText = ''

    let list_map_append = !!(dataGroundOverlay?.[0]?.coord_talhoes_agrupamento) ? (dataGroundOverlay?.[0]?.coord_talhoes_agrupamento) : dataGroundOverlay

    for (let i = 0; i < (list_map_append).length; i += 1) {
      const newDiv = document.createElement('div')
      newDiv.id = `map_${i}`
      divMaster.appendChild(newDiv)
    }

    onOverlayView(gerarGroupOverlay(verificarDataGround()))

  }, [dataGroundOverlay])

  return <Container ref={refMaster} />
}

export default CanvasInterpolation